import { render, staticRenderFns } from "./StarIconFilledBlack.vue?vue&type=template&id=572c4fdd"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('572c4fdd')) {
      api.createRecord('572c4fdd', component.options)
    } else {
      api.reload('572c4fdd', component.options)
    }
    module.hot.accept("./StarIconFilledBlack.vue?vue&type=template&id=572c4fdd", function () {
      api.rerender('572c4fdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/StarIconFilledBlack.vue"
export default component.exports